import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { serviceSettingsRoute } from '../route';

import { advisorClientAccessValidateSearchSchema } from './schema/advisorClientAccessValidateSearchSchema';

export const advisorClientAccessRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/advisor-client-access',
	component: lazyRouteComponent(
		() => import('./AdvisorClientAccessPage'),
		'AdvisorClientAccessPage',
	),
	validateSearch: advisorClientAccessValidateSearchSchema,
});
